import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconChevronDownSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-chevron-down-sharp__a)">
      <g clipPath="url(#icon-chevron-down-sharp__b)">
        <path
          stroke="currentColor"
          strokeLinecap="square"
          d="m6 10.001 6 6 6-6"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </g>
    <defs>
      <clipPath id="icon-chevron-down-sharp__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="icon-chevron-down-sharp__b">
        <path fill="currentColor" d="M0 24V0h24v24z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconChevronDownSharp);
export default Memo;
